import React from 'react';
import {Layout, ThemeColorName} from '@di-nxt/components';

type CellSpacerProps = {
  flex: number;
  width?: number | undefined;
  border?: boolean;
  borderColor?: ThemeColorName;
  pointerEvents?: 'none' | 'auto' | 'box-none' | undefined;
};

export const CellSpacer: React.FC<CellSpacerProps> = ({
  flex,
  width = undefined,
  children,
  border = false,
  borderColor,
  pointerEvents,
}) => {
  const hasSignificantFlex = flex !== undefined && flex > 0.001;

  return hasSignificantFlex ? (
    <Layout
      pointerEvents={pointerEvents}
      borderLeftWidth={border ? '1' : undefined}
      borderLeftColor={border ? 'transparent' : undefined}
      borderLeftStyle={border ? 'solid' : undefined}
      flex={width ? undefined : flex}
      width={width}
      minWidth={width}
      maxWidth={width}>
      {children}{' '}
    </Layout>
  ) : null;
};
